import { productsTypes } from "../constantes/actionTypes"

const initialState = []

export const products = (state = initialState, action) => {
    switch (action.type) {
        case productsTypes.GET_ALL_PRODUCTS_SUCCESS:
            return action.payload
        case productsTypes.GET_ALL_PRODUCTS_BY_SEARCH_SUCCESS:
            return state.concat(action.payload)
        case productsTypes.NEW_PRODUCT_SUCCESS:
            return [...state, action.payload]
        case productsTypes.UPDATE_PRODUCT_SUCCESS:
            const updateProduct = state.map(item => {
                if (item.id_Articulo.toString() === action.payload.id_Articulo)
                    return action.payload
                return item
            })  
            return updateProduct
        case productsTypes.DELETE_PRODUCT_SUCCESS:
            return state.filter(item => item.id_Articulo !== action.payload)
        case productsTypes.CLEAR_PRODUCTS_LIST:
            return initialState
        case productsTypes.NEW_PRODUCT_FAILURE:
        case productsTypes.UPDATE_PRODUCT_FAILURE:
        case productsTypes.DELETE_PRODUCT_FAILURE:
            return state
        case productsTypes.GET_ALL_PRODUCTS_FAILURE:
        case productsTypes.GET_ALL_PRODUCTS_BY_SEARCH_FAILURE:
            return initialState
        default:
            return state
    }
}